<template>
  <div class="submit-thseis-block">
    <div class="banner">
      <div class="container-block">
        <img src="@/assets/imgs/icon1.png" />
        <div class="info">
          <h1>预存金额</h1>
          <p>科研圈内人--让科研人员专注于科学本身！</p>
          <p>INSIDER OF SCIENCE</p>
          <p>丰富的服务内容，新颖的服务方式，</p>
          <p>专业的服务团队，优惠的服务价格。</p>
        </div>
        <div>
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{ total }}</p>
        </div>
      </div>
    </div>

    <Breadcrumb />

    <div class="container-block">
      <div class="card-block">
        <el-alert
          v-if="!isLogin"
          :closable="false"
          show-icon
          title="友情提示 Important Notice"
          type="warning"
        >
          <div class="flex">
            <span
              >为更好地为您提供服务，请首先进行注册/登录，本系统仅登录用户方可提交并生成订单，建议您先注册/登录再进行提交。</span
            >
            <span @click="toLogin" class="tel">立即登录 Login</span>
          </div>
        </el-alert>

        <div class="title">
          <img src="@/assets/imgs/icon24.png" />
          <span>联系信息</span>
          <div>为保证您的订单顺利完成，请务必填写真实信息</div>
          <!-- <el-link
            type="primary"
            href="/polish-paper?activeName=5"
            target="_blank"
            >※提交论文前，建议您先了解我们的服务流程。</el-link
          > -->
        </div>

        <el-form
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          label-position="top"
          ref="ruleForm"
        >
          <el-form-item label="姓名 Name" prop="name">
            <el-input placeholder="务必正确" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="电话 Mobile" prop="mobile">
            <el-input
              placeholder="务必正确"
              v-model="ruleForm.mobile"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱 Email" prop="email">
            <el-input
              placeholder="务必正确，后续将据此与您联系"
              v-model="ruleForm.email"
            ></el-input>
            <p>*后续重要通知将发送至上述邮箱，建议您不做修改</p>
          </el-form-item>
          <el-form-item label="通讯地址 Address" prop="address">
            <el-input
              placeholder="收快递使用"
              v-model="ruleForm.address"
            ></el-input>
            <p>请输入完整的通讯地址，我们将会把合同与发票邮寄到这个地址。</p>
          </el-form-item>
          <el-form-item
            label="单位名称 University or Institute"
            prop="unit_name"
          >
            <el-input
              placeholder="发票抬头，请务必保证准确"
              v-model="ruleForm.unit_name"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位税号 Tax No." prop="unit_tax_num">
            <el-input
              placeholder="开发票用，请务必保证准确"
              v-model="ruleForm.unit_tax_num"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="发票类型 Invoice type" prop="invoice_type">
            <el-select
              placeholder="开发票用，请务必保证准确"
              v-model="ruleForm.invoice_type"
            >
              <el-option
                label="润色费：【0】【论文题目】"
                value="润色费：【0】【论文题目】"
              ></el-option>
              <el-option
                label="编辑费：【1000】【论文题目】"
                value="编辑费：【1000】【论文题目】"
              ></el-option>
              <el-option
                label="文献检索费：【1000】"
                value="文献检索费：【1000】"
              ></el-option>
              <el-option
                label="数据处理费：【1000】【被处理数据的名称】"
                value="数据处理费：【1000】【被处理数据的名称】"
              ></el-option>
              <el-option
                label="咨询费：【0】【资讯内容】"
                value="咨询费：【0】【资讯内容】"
              ></el-option>
              <el-option
                label="其它（手工输入）"
                value="其它（手工输入）"
              ></el-option>
            </el-select>
            <p>
              请选择您需要的发票类型，以方便您财务报销。默认开具“论文编辑费”发票，如需其它内容请务必在文章
              WORD里红字标注或邮件电话说明。
            </p>
          </el-form-item> -->
          <!-- <el-form-item
            label="其他发票类型"
            v-if="ruleForm.invoice_type == '其它（手工输入）'"
          >
            <el-input
              placeholder="其他发票类型"
              v-model="ruleForm.invoice_type_else"
            ></el-input>
            <p>
              如您选择了“其它”的发票类型，请在下面手工输入您需要的发票类型。
            </p>
          </el-form-item> -->

          <el-form-item label="预存金额" prop="amount_of_money">
            <el-input
              placeholder="预存金额，请务必保证准确"
              v-model="ruleForm.amount_of_money"
              @keyup.native="amountMoney"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="发票形式" prop="invoice_class">
            <el-select
              placeholder="电子发票/纸质发票"
              v-model="ruleForm.invoice_class"
            >
              <el-option label="电子发票" value="电子发票"></el-option>
              <el-option label="纸质发票" value="纸质发票"></el-option>
            </el-select>
            <p>
              请选择您需要的发票类型，以方便您财务报销。默认开具“论文编辑费”发票，如需其它内容请务必在文章
              WORD里红字标注或邮件电话说明。
            </p>
          </el-form-item> -->

          <!-- <el-form-item
            label="收件地址"
            v-if="ruleForm.invoice_class == '纸质发票'"
          >
            <el-input
              placeholder="纸质发票收件地址"
              v-model="ruleForm.invoice_type_else"
            ></el-input>
            <p>
              如您选择了“纸质发票”的发票类型，请在下面手工输入您的收件地址。
            </p>
          </el-form-item> -->

          <el-form-item label="备注 Remarks">
            <el-input
              placeholder="请在此输入您的特殊需求，中英文均可。"
              type="textarea"
              v-model="ruleForm.remarks"
            ></el-input>
            <p>
              请按如下格式（示例）告知开票形式： 共1万元，开具5张发票，分别是：
              1.润色费3000元，合同中的论文题目为：xxxxxxx
              2.编辑费2000元，合同中文档标题为：xxxxxx
              3.数据处理费3000元，合同中数据处理的名称为：xxxxx
              4.信息检索费2000元，联系客服定制合同。
              5.其他xxxx元，联系客服定制合同。
              纸质发票需要快递，为了方便，我们默认开具电子发票，如您单位有特殊需求，请在上面备注“需要纸质发票，并告知快递地址”。
            </p>
            <!-- 若您的本次订单得到了本平台其他会员的推荐，请在此备注该会员注册时使用的邮箱，该推荐人将因本订单获得额外积分。详情请见 -->
            <!-- <a @click="toReward" href="javascript:;" rel="noopener noreferrer">推荐奖励</a>页面。 -->
          </el-form-item>

          <el-form-item label="支付截图" prop="deposit_img">
            <!-- <p>
              请通过支付宝扫码缴纳200元发票押金，并将支付截图上传（请在支付时备注您的姓名），待您收到发票完成汇款后，此押金将全额原路径返还。上传的单个文件大小不超过{{
                $store.state.user.maxFileName
              }}。
            </p>
            <img class="alipay" src="@/assets/imgs/alipay.png" /> -->
            <!-- :on-change="handleChange" -->
            <el-upload
              :action="`${$store.state.user.urlLink}api/ajax_file`"
              :before-upload="beforeAvatarUpload"
              :file-list="fileList"
              :on-error="handleError"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              class="upload-payment-voucher"
              accept=".jpg, .jpeg, .png"
              list-type="picture"
              ref="uploadPaymentVoucher"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div class="el-upload__tip" slot="tip">
                请上传jpg、png格式的付款凭证截图。上传的文件大小不能超{{
                  $store.state.user.maxFileName
                }}。<span style="color: #f46c6c"
                  >上传成功后请检查缩略图是否正常显示，若不正常，请重新上传！</span
                >
              </div>
            </el-upload>
            <div class="alipay">
              <h3 style="line-height: 1; margin: 10px 0 10px 0">我们提供两种付费模式，请根据情况选择：</h3>

              <div class="flex">
                <div style="width: 56%">
                  <h4>
                    A.先交押金，待对公汇款到账后退押金 <br/>
                    您可先用个人支付宝扫下方二维码缴纳500元押金，并上传支付截图，我们将为您提供发票等报销材料，之后您可在30天内通过对公汇款或公务卡扫码等形式缴纳全款，我们收到全款后将全额退还押金。 对公汇款账号为：
                  </h4>
                  <h4>
                    户名：北京文雅信达科技有限公司
                    开户行：招商银行北京金融街支行 账号： 110936956910201
                  </h4>

                  <img
                    style="width: 250px; margin-bottom: 20px"
                    src="@/assets/imgs/alipay-yajin.png"
                  />
                </div>

                <div style="width: 40%">
                  <h4>
                    B.使用储蓄卡/信用卡/公务卡直接扫下码支付全款【推荐】
                    为了减少流程，建议您直接扫下方收款码完成全款支付，支付完毕后上传支付截图，我们将即刻开始服务并准备报销材料。
                  </h4>

                  <img
                    style="width: 250px; margin-bottom: 20px"
                    src="@/assets/imgs/bank-quankuan.png"
                  />
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="邀请码">
            <el-input
              placeholder="若您的本次订单得到了他人的邀请与推荐，请在此填入其给您的“邀请码”。"
              v-model="ruleForm.invite_code"
            ></el-input>
            <p>
              请确保邀请码正确，您的推荐人也将因您的本次订单获得相应积分奖励。我们也希望您能够将我们的服务推荐给您的朋友，“赠人玫瑰手有余香”式的积分奖励规则详见<a
                @click="toReward"
                href="javascript:;"
                rel="noopener noreferrer"
                >“积分奖励”</a
              >。
            </p>
          </el-form-item>

          <el-form-item prop="is_agree_pro">
            <span class="color-red">*</span>
            <el-checkbox v-model="ruleForm.is_agree_pro"
              >勾选确认服务协议</el-checkbox
            >
            <span @click="textInfoDialogVisible = true" class="agreement"
              >《科研圈内人服务协议》</span
            >
          </el-form-item>
        </el-form>

        <el-alert
          :closable="false"
          show-icon
          title="重要提示 Important Notice"
          type="warning"
        >
          <div class="flex">
            <span>
              您点击提交后，我们的对接编辑将在12小时内在网站系统内进行报价，您届时会收到邮件提醒，按照提醒登录网站系统进行确认即可，请注意查收邮件。只有在接收到您在系统中的确认后，您的稿件方能进入润色流程，所约定的润色期限也以您在系统中确认后开始计算。请务必确保邮箱和电话准确无误！
              <br />After your submission, please keep an eye on your email box.
              We will update the price and important guidance in the system
              within 12 hours, and then you will receive this notification in
              your email. Then you need to log in at our official website and
              confirm the price. Please note that without your confirmation,
              your paper will not be processed to the next step. Please double
              check your Email address and phone number before submission.
            </span>
          </div>
        </el-alert>

        <div class="align-center">
          <el-button
            :loading="submitLoading"
            @click="submitForm('ruleForm')"
            type="primary"
            >信息确认无误，立即提交论文 SUBMIT</el-button
          >
        </div>
      </div>
    </div>

    <!--隐私条款、服务条款-->
    <TextInfo
      :dialogVisible.sync="textInfoDialogVisible"
      :type="textInfoType"
    />
  </div>
</template>

<script>
/**
 * @description 提交论文
 */
import * as api from '@/api/recharge'
import * as commonFunc from '@/utils/common-func'
// 面包屑
import Breadcrumb from '@/components/Breadcrumb'
// 隐私条款、服务条款 展示隐藏
import TextInfo from '@/components/TextInfo'

export default {
  name: 'Recharge',
  components: {
    Breadcrumb,
    TextInfo
  },
  data() {
    // 校验文件上传
    const uploadFile = (rule, value, callback) => {
      if (this.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    }

    // 校验勾选确认服务协议
    const confirmAgreement = (rule, value, callback) => {
      if (!this.ruleForm.is_agree_pro) {
        callback(new Error('请勾选确认服务协议《科研圈内人服务协议》'))
      } else {
        callback()
      }
    }

    //验证手机号是否合法
    const validateTel = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('手机号不能为空'))
      } else {
        const telReg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (telReg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确手机号'))
        }
      }
    }

    //验证邮箱是否合法
    const validateEmail = (rule, value, callback) => {
      // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      const emailTrue = commonFunc.getCharCount(value, '@') == 1
      if (value == '') {
        return callback(new Error('邮箱不能为空'))
        // callback();
        // } else if (mailReg.test(value)) {
      } else if (emailTrue) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱格式'))
      }
    }

    return {
      textInfoDialogVisible: false, // 隐私条款、服务条款 展示隐藏
      textInfoType: 'service', // 隐私条款（privacy）、服务条款（service） 展示隐藏

      total: 0, // 订单总量
      submitLoading: false, // 提交按钮loading
      // 提交订单的参数
      ruleForm: {
        name: '', // 姓名
        mobile: '', // 邮箱
        email: '', // 邮箱
        address: '', // 地址
        unit_name: '', // 公司名称
        unit_tax_num: '', // 公司税号
        // invoice_type: '', // 发票类型
        // // invoice_type_else: '', // 其他发票类型，手动录入
        amount_of_money: '', // 金额
        // invoice_class: '', // 发票形式
        deposit_img: '', // 押金凭证
        remarks: '', // 备注
        invite_code: '', // 邀请码
        is_agree_pro: false // 是否统一用户协议
      },

      // 上传文件的列表
      fileList: [],

      rules: {
        name: [
          {
            required: true,
            message: '请输入姓名 Name',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            validator: validateTel,
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '请输入通讯地址 Address',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        unit_name: [
          {
            required: true,
            message: '请输入单位名称 University or Institute',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        unit_tax_num: [
          {
            required: true,
            message: '请输入单位税号 Tax No.',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        is_agree_pro: [
          {
            required: true,
            validator: confirmAgreement,
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        invoice_type: [
          {
            required: true,
            message: '请选择发票类型 Invoice type',
            trigger: 'change'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        invoice_class: [
          {
            required: true,
            message: '请选择发票形式',
            trigger: 'change'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        deposit_img: [
          { required: true, validator: uploadFile, trigger: 'blur' }
        ],

        amount_of_money: [
          {
            required: true,
            message: '请输入发票金额',
            trigger: 'blur'
          }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ]
      },
      isLogin: true // 是否已经登陆
    }
  },

  // 计算属性
  computed: {
    userInfoWatch() {
      return this.$store.state.user.userName
    }
  },
  // 监听
  watch: {
    userInfoWatch(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.ruleForm.name = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.username
        : ''
      this.ruleForm.email = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.email
        : ''
    },

    ruleForm: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        localStorage.setItem('recharge_form', JSON.stringify(this.ruleForm))
      },
      deep: true
    },

    fileList: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        localStorage.setItem('recharge_file', JSON.stringify(this.fileList))
      },
      deep: true
    }
  },
  mounted() {},
  created() {
    this.getOrderTotal() //获取订单总数
    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      this.isLogin = false
      this.toLogin()
    }

    // 页面初始化载入用户信息
    this.ruleForm.name = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.username
      : ''
    this.ruleForm.email = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.email
      : ''

    // 在表单没有提交成功的时候，默认添加到本地缓存中，防止刷新丢失
    this.ruleForm = localStorage.getItem('recharge_form')
      ? JSON.parse(localStorage.getItem('recharge_form'))
      : this.ruleForm
    this.fileList = localStorage.getItem('recharge_file')
      ? JSON.parse(localStorage.getItem('recharge_file'))
      : this.fileList
  },
  methods: {
    /**
     * @description 发票金额只能输入正整数
     */
    amountMoney() {
      const _this = this
      _this.ruleForm.amount_of_money = _this.ruleForm.amount_of_money.replace(
        /[^\.\d]/g,
        ''
      )
      _this.ruleForm.amount_of_money = _this.ruleForm.amount_of_money.replace(
        '.',
        ''
      )
    },

    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 注册提交
     */
    submitForm(formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.submitLoading = true
          const _param = JSON.parse(JSON.stringify(this.ruleForm))
          _this.fileList.map((item) => {
            _param.deposit_img = _param.deposit_img + ',' + item.response.data
          })
          _param.deposit_img = _param.deposit_img.substring(1)
          _param.is_agree_pro = this.ruleForm.is_agree_pro ? '1' : '0'
          api
            .submitOrder(_param)
            .then((res) => {
              _this.submitLoading = false

              // 清理本地缓存的论文润色的表单信息
              localStorage.removeItem('recharge_form')
              localStorage.removeItem('recharge_file')
              _this.$message.success('提交成功！')
              _this.$router.push({
                path: '/order?activeName=recharge'
              })
            })
            .catch((err) => {
              _this.submitLoading = false
              console.log(err)
              if (err == 'Error: 请登录') {
                setTimeout(() => {
                  _this.toLogin() // 注册、登陆
                }, 500)
              }
            })
        } else {
          _this.$message.error('请根据系统提示将必填信息填写完整，再进行提交。')
          console.log('error submit!!')
          return false
        }
      })
    },

    // /**
    //  * @description 上传文件
    //  */
    // handleChange(file, fileList) {
    //   this.fileList = fileList.slice(-10)
    // },

    /**
     * @description 上传失败的钩子函数
     */
    handleError(err, file, fileList) {
      // this.$message.error('上传失败，请再次尝试！')
      this.$message.error(err.error_msg)
    },

    /**
     * @description 上传成功的钩子函数
     */
    handleSuccess(response, file, fileList) {
      // 只保留一张图片
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.$refs.uploadPaymentVoucher.clearFiles()
      this.fileList = []
      if (response.error_msg == '请登录') {
        this.$message.error('登录之后，才能允许上传文件，请先登录！')
        this.fileList = []
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      } else if (response.error_code == 1) {
        this.$message.error(response.error_msg)
        this.fileList = []
      } else {
        this.fileList = fileList.slice(-10) // 最大10个文件
      }
    },

    /**
     * @description 限制上传文件的大小
     */
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isOverSize =
        file.size / 1024 / 1024 <= this.$store.state.user.maxFile

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isOverSize) {
        this.$message.error(
          `上传的文件大小不能超过${this.$store.state.user.maxFileName}!`
        )
      }
      return isOverSize
    },

    /**
     * @description 删除文件
     */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    /**
     * @description 点击去登录
     */
    toLogin() {
      this.$store.dispatch('user/toLogin', { toggle: true })
    },

    /**
     * @description 新窗口打开推荐奖励
     */
    toReward() {
      window.open('/polish-paper?activeName=2')
    }
  }
}
</script>
<style lang="scss" scoped>
.submit-thseis-block {
  .banner {
    background: #262525;
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    .info {
      width: 650px;
      color: #ffffff;
    }
  }

  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 20px 0 0 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }

      & > div {
        font-size: 14px;
        color: #98a5a6;
        margin: 0 0 0 10px;
        flex-grow: 1; /* default 0 */
      }

      a {
        text-decoration: underline;
      }
    }

    /deep/.el-form {
      // margin: 50px 200px;

      .el-form-item {
        padding: 0 200px;
        margin: 30px 0;
      }

      // .el-button {
      //   margin: 100px 0 0 0;
      //   width: 550px;
      // }

      .el-form-item__label {
        padding-bottom: 0;
      }

      .el-select {
        width: 100%;
      }

      p {
        margin: 10px 0 0 0;
        line-height: 1.5;
      }

      .el-upload__tip {
        margin: 0;
        line-height: 1.5;
      }

      .flex {
        display: flex;
        justify-content: space-around;
      }

      .upload-payment-voucher .el-upload {
        text-align: left;
      }

      .alipay {
        h4 {
          text-align: center;
          font-size: 14px;
          color: #606266;
          margin: 0 0 10px 0;
          font-weight: normal;
          line-height: 1.5;
        }

        img {
          display: block;
          width: 140px;
          margin: 0 auto;
        }
      }

      a {
        color: $colorNormal;
      }

      .agreement {
        color: $colorNormal;
        cursor: pointer;
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #606266;
      }

      .color-red {
        color: #f46c6c;
        margin-right: 4px;
      }
    }

    .align-center {
      text-align: center;

      .el-button {
        width: 500px;
        height: 70px;
        font-size: 22px;
      }
    }
  }

  /deep/.el-alert {
    margin: 0 0 15px 0;
    .el-alert__content {
      width: 100%;
    }

    .el-alert__title {
      font-size: 16px;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 180px;
      height: 36px;
      line-height: 36px;
      border-radius: 3px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -20px;
    }
  }
}
</style>